var map = {
	"./amor-face-0.jpg": "a81f",
	"./amor-face-1.jpg": "36fb",
	"./amor-face-2.jpg": "9c0b",
	"./amor-face-3.jpg": "6dd0",
	"./amor-face-4.jpg": "66c3",
	"./amor-face-5.jpg": "0219",
	"./amor-face-6.jpg": "46f0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c0d9";